<template>
  <div class="product__info-card">
    <div class="product__info-body">
      <!-- <div class="product__badge tag-badge tag-badge--sale">Sale (x)</div> -->
      <div class="product__prices-stock">
        <div class="product__prices">
          <div class="product__price product__price--current">{{ toUSD(whi_product.extended_price) }}</div>
          <div class="product__price--core" v-if="whi_product.core_charge > 0">
            +{{ toUSD(whi_product.core_charge) }} Refundable Core Deposit
          </div>
        </div>
      </div>
      <div class="in-stock">
        <div class="status-badge status-badge--style--success product__stock status-badge--has-text">
          <div class="status-badge__body">
            <div class="status-badge__text">
              <!-- Available (x) -->
              <availability-display :stock-quantity="whi_product.stockquantity" :backordered="false" />
            </div>
            <div class="status-badge__tooltip" tabindex="0" data-toggle="tooltip" title="In&#x20;Stock" ></div>
          </div>
        </div>
      </div>
      <div class="product__meta">
        <table>
          <tr>
            <th>Item</th>
            <td>{{ whi_product.sku }}</td>
          </tr>
          <tr>
            <th>Manufacturer</th>
            <td><a href="javascript:void(0);">{{ whi_product.manufacturerdesc }}</a></td>
          </tr>
          <tr>
            <!-- <th></th> -->
            <td colspan="2">{{ whi_product.description }}</td>
          </tr>
          <tr>
            <!-- <th></th> -->
            <td colspan="2">{{ whi_product.QTDESC }}</td>
          </tr>
          <tr>
            <!-- <th></th> -->
            <td colspan="2" v-html="whi_product.use_description" class="whi_desc"></td>
          </tr>
          <tr v-if="whi_product.QIGDSC != ''">
            <!-- <th></th> -->
            <td colspan="2">{{ whi_product.QIGDSC }}</td>
          </tr>
          <tr v-if="whi_product.DEDESC != ''">
            <td colspan="2">{{ whi_product.DEDESC }}</td>
          </tr>

          <tr v-for="(desc, i) in whi_product.txt_list" :key="i">
            <td v-html="desc.ETXITUSE" colspan="2" class="whi_desc"></td>
          </tr>

          <tr v-if="whi_product.list_price > 0">
            <th>List Price</th>
            <td class="notranslate">{{ toUSD(whi_product.list_price) }}</td>
          </tr>
          <tr v-if="xRef">
              <th>X-Ref ({{ whi_product.xref_mfg_desc }})</th>
              <!-- <td>{{ whi_product.XRITMC }}</td> -->
          </tr>
          <!-- <tr>
              <th>X-Ref (Atlantic & Pacific)</th>
              <td>{{ whi_product.XRMFGC }}</td>
          </tr> -->
        </table>
      </div>
    </div>
    <div class="product__actions">
        <div class="product__actions-item product__actions-item--quantity">
            <div class="input-number">
                <input
                class="input-number__input form-control form-control-lg"
                type="number"
                min="1"
                :value="modelValue"
                @change="$emit('update:modelValue', $event.target.value)"
                />
                <div class="input-number__add" @mousedown.left="startChange('add')" @mouseup="stopChange" @mouseleave="stopChange"></div>
                <div class="input-number__sub" @mousedown.left="startChange('sub')" @mouseup="stopChange" @mouseleave="stopChange"></div>
            </div>
        </div>
          <!-- v-if="whi_product.stockquantity > 0" -->
        <div class="product__actions-item product__actions-item--addtocart">
            <button class="btn btn-primary btn-lg btn-block" @click="addToCart()">Add to Cart</button>
        </div>
        <div class="product__actions-divider"></div>

        <div class="btn-related-items">
          <div class="btn btn-sm btn-dark-blue btn-check-stock btn-related-items">
            <a class="btn-dark-blue" href="#related" @click="openRelatedTypes"> 
              Select Related Items
            </a>
          </div>
      </div>
    </div>

    <div class="product__tags-and-share-links">
      <!-- <div class="product__tags tags tags--sm">
        <div class="tags__list">
          <a href="" v-for="tag in whi_product.tags" :key="tag">{{tag}}</a>
        </div>
      </div> -->
      <div class="product__share-links share-links">
        <ul class="share-links__list">
          <li class="share-links__item share-links__item--type--like">
            <a href="#">Share on Facebook (x)</a>
          </li>
          <li class="share-links__item share-links__item--type--tweet">
            <a href="#">Tweet (x)</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <add-to-cart-dialog :open="hasAdded" @close="hasAdded = false" 
      :item_name="added_to_cart.sku" 
      :item_image="added_to_cart.item_image"
      :quantity="added_to_cart.quantity">
  </add-to-cart-dialog>

  <related-part-types 
      ref="relatedPartType"
      @selected_type="selected_type">
  </related-part-types>

  <related-items ref="relatedItems"
      @open-smart-page="openSmartPageDialog"
      @open-related-type="openRelatedTypes"
      >
  </related-items>

</template>


<script>
import Price from '../../../mixins/price.js';
import MixinCart from '../../../mixins/cart.js';
import { mapGetters } from 'vuex';
import AvailabilityDisplay from '../orderparts/AvailabilityDisplay.vue';
import AddToCartDialog from '../../common/product/AddToCartDialog.vue';
import RelatedItems from '../searchresults/RelatedItems.vue';
import RelatedPartTypes from '../searchresults/RelatedPartTypes.vue';

export default {
    components: {
        "availability-display": AvailabilityDisplay,
        "add-to-cart-dialog" : AddToCartDialog,
        "related-items" : RelatedItems,
        "related-part-types" : RelatedPartTypes
    },
    data() {
      return {
        modelValue: 0,
        quantity: 0,
        hasAdded: false,
        added_to_cart : {
            item_name: '',
            quantity : 1,
            item_image: '',
        },
      }
    },
    mixins: [Price, MixinCart],
    computed: {
        ...mapGetters('product', [
            'whi_smart_url',
            'whi_product',
        ]),
    },

    methods: {
      startChange(form) {
          if (!this.interval) {
              this.interval = setInterval(() => {
                  let qty = 0
                  if (!isNaN(parseInt(this.modelValue))) {
                      qty = parseInt(this.modelValue)
                  }
                  if (form === 'add') {
                      qty += 1;
                  } else {
                      qty = (qty - 1 < 0) ? qty = 0 : qty - 1;
                  }
                  this.modelValue = qty;
              }, 100)
          }
      },

      stopChange() {
          clearInterval(this.interval);
          this.interval = false;
      },

      addToCart() {
        this.$store.dispatch("message/clearKeyedMessage", this.sourcePage);
        let linetotal = 0;
        
        // if (this.$store.getters.customer != 'B2C') {
        //   linetotal = this.quantity * this.whi_product.extended_price;
        // } else {
        this.quantity = this.modelValue;
        linetotal = this.quantity * this.whi_product.extended_price;
        const defaultLoc = this.$store.getters.getCustomerDetails;
        // }
        // console.log(this.product);

        let productData = {
            ID: this.whi_product.sku,
            item: this.whi_product.sku,
            desc: this.whi_product.description,
            manufacturer: this.whi_product.manufacturer,
            image: this.whi_product.QITTMB,
            quantity: this.quantity,
            listprice: this.whi_product.list_price,
            corecharge: this.whi_product.core_charge,
            yourprice: this.whi_product.extended_price,
            shipping: 0,
            linetotal: linetotal,

            // new fields
            XRMFGC: this.whi_product.XRMFGC,
            XRITMC: this.whi_product.XRITMC,
            IMIGSA: this.whi_product.IMIGSA,
            IMISVALID: this.whi_product.IMISVALID,
            
            stockquantity: this.whi_product.stockquantity,
            locationid: this.whi_product.location,
            locationname: defaultLoc.defaultlocationname,
            locationcity: defaultLoc.defaultlocationcity,
            locationstate: defaultLoc.defaultlocationstate,
        }

        let validationresult = this.addToCartValidation(productData);
        
        if (validationresult.status === 'OK') {
            this.$store.dispatch("cart/addToCart", productData);

            this.added_to_cart = {
                item_name: this.whi_product.manufacturer + ' ' + this.whi_product.description + ' ' + this.whi_product.sku,
                quantity : this.quantity,
                item_image: this.whi_product.QITTMB,
            }

            this.hasAdded = true;
        } else {
          let storedmessages = [];
          storedmessages.push(validationresult.message);

          this.$store.dispatch("message/addKeyedMessage", {
            "key": this.sourcePage,
            "messages": storedmessages
          });
        }
      },
      
      openRelatedTypes() {
          // console.log(product);
          this.relatedProduct = this.whi_product;
          // this.showRelated;
          this.$refs.relatedPartType.getRelatedTypes(this.whi_product);
      },

      selected_type(type) {
          this.$refs.relatedItems.getRelatedItems(this.relatedProduct, type);
      }
    }
    
}
</script>

<style>
  td.whi_desc p {
    margin: 0px !important;
  }
</style>